import {COUNTRY_CODES} from './countryCodes';

const DRIVING_LICENSES = {
  drivingLicense: 'DL',
  drivingLicenseES: 'ES_C',
  drivingLicenseCZ: 'CZ_DL',
  drivingLicenseAT: 'AT_DL',
  drivingLicenseDE: 'DE_DL',
  drivingLicenseGR: 'GR_DL',
  drivingLicenseGB: 'GB_DL',
  drivingLicenseIT: 'IT_PATEN',
  drivingLicenseRO: 'RO_DL',
  drivingLicenseUS: 'US_DL',
  drivingLicenseCA: 'CA_DL',
};

const IDENTITY_CARDS = {
  identityCard: 'I',
  identityCardES: 'ES_I',
  identityCardIT: 'IT_IDELE',
  identityCardPaperIT: 'IT_IDENT',
  identityCardPT: 'PT_B',
  identityCardCZ: 'CZ_ID',
  identityCardAT: 'AT_ID',
  identityCardDE: 'DE_ID',
  identityCardGR: 'GR_ID',
  identityCardGB: 'GB_ID',
  identityCardCO: 'CO_I',
  identityCardMinorCO: 'CO_IM',
  identityCardOldCO: 'CO_ID_OLD',
  identityCardForeignCO: 'CO_EID',
  identityCardUS: 'US_ID',
  identityCardRO: 'RO_ID',
};

const PASSPORTS = {
  passport: 'P',
  passportPT: 'PT_P',
  passportIT: 'IT_PASOR',
  passportCZ: 'CZ_P',
  passportAT: 'AT_P',
  passportDE: 'DE_P',
  passportGR: 'GR_P',
  passportGB: 'GB_P',
  passportES: 'ES_P',
  passportCO: 'CO_P',
  passportRO: 'RO_P',
  armyIdGR: 'GR_ARMY_ID',
};

const DNI_DOCUMENTS = {
  dniES: 'ES_D',
  dniOldGreek: 'GR_ID_OLD',
};

const RESIDENCE_PERMITS = {
  dubaiResidencePermit: 'AE_RP',
  spanishResidencePermitEU: 'ES_N',
  spanishForeignerResidencePermitNIE: 'ES_X',
  columbianResidencePermit: 'CO_FID',
};

const DOCUMENTS_TYPES = {
  diplomaticPassportIT: 'IT_PASDI',
  diplomaticIdentityIT: 'IT_CIDIP',
  diplomaticIdCO: 'CO_DIP',
  servicePassportIT: 'IT_PASSE',
  othersDocumentsPT: 'PT_O',
  othersDocumentsAT: 'AT_O',
  workPermitGR: 'GR_WORK_PERMIT',
  foreignDocumentCO: 'CO_FD',
  identityCertificateIT: 'IT_CERID',
  civilRegistrationCO: 'CO_CR',
  temporaryProtectionCO: 'CO_TEM',
  ...DNI_DOCUMENTS,
  ...RESIDENCE_PERMITS,
  ...PASSPORTS,
  ...IDENTITY_CARDS,
  ...DRIVING_LICENSES,
};

function getRemappedDocType({
  docType,
  countryCode,
  nationality,
}: {
  docType?: string | null;
  countryCode?: string;
  nationality?: string;
}) {
  const ID_DOC_TYPES_LIST = ['ID', 'CI', 'C'];
  const DRIVING_LICENCE = 'DL';
  const RESIDENCE_PERMITS_LIST = ['IR', 'IM', 'IX'];

  if (docType && ID_DOC_TYPES_LIST.includes(docType)) {
    switch (countryCode) {
      case COUNTRY_CODES.spain:
        return nationality === COUNTRY_CODES.spain
          ? DOCUMENTS_TYPES.dniES
          : DOCUMENTS_TYPES.identityCardES;
      case COUNTRY_CODES.italy:
        return DOCUMENTS_TYPES.identityCardIT;
      case COUNTRY_CODES.portugal:
        return DOCUMENTS_TYPES.identityCardPT;
      case COUNTRY_CODES.colombia:
        return DOCUMENTS_TYPES.identityCardCO;
      case COUNTRY_CODES.romania:
        return DOCUMENTS_TYPES.identityCardRO;
      case COUNTRY_CODES.austria:
        return DOCUMENTS_TYPES.identityCardAT;
      case COUNTRY_CODES.germany:
        return DOCUMENTS_TYPES.identityCardDE;
      default:
        return DOCUMENTS_TYPES.identityCard;
    }
  } else if (docType && RESIDENCE_PERMITS_LIST.includes(docType)) {
    switch (countryCode) {
      case COUNTRY_CODES.spain:
        return DOCUMENTS_TYPES.spanishResidencePermitEU;
      case COUNTRY_CODES.italy:
        return DOCUMENTS_TYPES.identityCardIT;
      case COUNTRY_CODES.portugal:
        return DOCUMENTS_TYPES.othersDocumentsPT;
    }
  } else if (docType === DRIVING_LICENCE) {
    switch (countryCode) {
      case COUNTRY_CODES.romania:
        return DOCUMENTS_TYPES.drivingLicenseRO;
      case COUNTRY_CODES.usa:
        return DOCUMENTS_TYPES.drivingLicenseUS;
      case COUNTRY_CODES.canada:
        return DOCUMENTS_TYPES.drivingLicenseCA;
      case COUNTRY_CODES.austria:
        return DOCUMENTS_TYPES.drivingLicenseAT;
      case COUNTRY_CODES.germany:
        return DOCUMENTS_TYPES.drivingLicenseDE;
      default:
        return DOCUMENTS_TYPES.drivingLicense;
    }
  } else if (docType === DOCUMENTS_TYPES.passport) {
    switch (countryCode) {
      case COUNTRY_CODES.spain:
        return DOCUMENTS_TYPES.passportES;
      case COUNTRY_CODES.italy:
        return DOCUMENTS_TYPES.passportIT;
      case COUNTRY_CODES.portugal:
        return DOCUMENTS_TYPES.passportPT;
      case COUNTRY_CODES.colombia:
        return DOCUMENTS_TYPES.passportCO;
      case COUNTRY_CODES.romania:
        return DOCUMENTS_TYPES.passportRO;
      case COUNTRY_CODES.austria:
        return DOCUMENTS_TYPES.passportAT;
      case COUNTRY_CODES.germany:
        return DOCUMENTS_TYPES.passportDE;
      default:
        return DOCUMENTS_TYPES.passport;
    }
  }
}

function getRemappedOfficialDocType({docType}: {docType?: string | null}) {
  if (docType && Object.values(DRIVING_LICENSES).includes(docType)) {
    return 'DL';
  }

  if (docType && Object.values(IDENTITY_CARDS).includes(docType)) {
    return 'ID';
  }
}

const dniValidation = [DNI_DOCUMENTS.dniES, DRIVING_LICENSES.drivingLicenseES];
const nieValidation = [DOCUMENTS_TYPES.spanishResidencePermitEU];

export {
  DOCUMENTS_TYPES,
  getRemappedDocType,
  getRemappedOfficialDocType,
  dniValidation,
  nieValidation,
};
